import endpoint from "../../config/endpoints";

export const OptionalHolidayJson = {
    showSaveNextBtn: true,
    formPath: "/add-optional-holiday-for-self",
    formPathForSalesTeam: "/add-optional-holiday-for-under-team",
    apiBaseURL: endpoint.holidayTransaction,
    changeExcel: endpoint.exportData,
    screenTitle: "Optional Holiday",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Holiday Structure",
    showExcelDownload: true,
    excelFileName: "Holiday Structure",
    formPathView: "/add-optional-holiday-for-self",
    isActiveURL: endpoint.holidayStructureHeader + "/update-is-active",
    openFormPathStatus: "/encashed-leave-assignation",


    tableColumnsToFilter: [
        {
            columnDisplayName: "Holiday",
            columnKeyName: "name",
            isChecked: true,
        },
        {
            columnDisplayName: "Day",
            columnKeyName: "day",
            isChecked: true,
        },
        {
            columnDisplayName: "Month",
            columnKeyName: "monthName",
            isChecked: true,
        },
    ],

    tableColumnsToFilterForSalesTeam: [
        {
            columnDisplayName: "Sales Team Name",
            columnKeyName: "salesTeamName",
            isChecked: true,
        },
        {
            columnDisplayName: "Type",
            columnKeyName: "designation",
            isChecked: true,
        },
        {
            columnDisplayName: "Holiday",
            columnKeyName: "name",
            isChecked: true,
        },
        {
            columnDisplayName: "Day",
            columnKeyName: "day",
            isChecked: true,
        },
        {
            columnDisplayName: "Month",
            columnKeyName: "monthName",
            isChecked: true,
        },
    ],

    fieldMeta: [
        {
            label: "Available Optional Holidays",
            controlType: "autocomplete",
            placeHolder: "Select Available Optional Holidays",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "optionalHolidayDetail",
            dataKey: "optionalHolidayDetailId",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],

    fieldMetaForSalesTeam: [
        {
            label: "Sales Team",
            controlType: "autocomplete",
            placeHolder: "Select Sales Team",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "salesTeamDetail",
            dataKey: "salesTeam",
            getListId: "salesTeam",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Available Optional Holidays",
            controlType: "autocomplete",
            placeHolder: "Select Available Optional Holidays",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "optionalHolidayDetail",
            dataKey: "optionalHolidayDetailId",
            getListId: "optionalHolidayDetailId",
            getListFrom: "salesTeam",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};

